module.exports = __webpack_public_path__ + "media/images/ControllerVertical-905971c3.jpg";